var map = {
	"./align-center.svg": 34,
	"./align-justify.svg": 35,
	"./align-left.svg": 36,
	"./align-right.svg": 37,
	"./arrow.svg": 38,
	"./audio.svg": 39,
	"./background.svg": 40,
	"./bold.svg": 41,
	"./button-refresh.svg": 42,
	"./clean.svg": 43,
	"./close.svg": 44,
	"./color.svg": 45,
	"./edit.svg": 46,
	"./error.svg": 47,
	"./formatbrush.svg": 48,
	"./hLink.svg": 49,
	"./image.svg": 50,
	"./import.svg": 51,
	"./indent.svg": 52,
	"./italic.svg": 53,
	"./list-bullet.svg": 54,
	"./list-ordered.svg": 55,
	"./loading_audio.svg": 56,
	"./pause_audio.svg": 57,
	"./pdf.svg": 58,
	"./play_audio.svg": 59,
	"./play_video.svg": 60,
	"./redo.svg": 61,
	"./splitline.svg": 62,
	"./subtitle.svg": 63,
	"./underline.svg": 64,
	"./undo.svg": 65,
	"./uploadf.svg": 66,
	"./video.svg": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;